import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class SignUpRequest
*  Данные для выполнения регистрации в системе
*/
export class SignUpRequest extends ActiveModel {

/**
  * login
  * Логин аккаунта пользователя: Email или номер телефона в зависимости от настроек веб-витрины<br>
  */
  @ActiveField('')
  login: string = ''


  /**
  * longSession
  * Если true, то создать "долгоживущую" сессию, иначе создать сессию на короткий промежуток времени<br>  */
  @ActiveField()
  longSession?: boolean
}
